import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { clearAuthData, selectAuth } from '../../store/auth/AuthSlice';
import { createSelector } from '@reduxjs/toolkit';
import { clearSentryUser } from '../../utils/sentry';
//import AuthContext from '../firebase/FirebaseContext';

import { AuthContext } from '../jwt/JwtContext';
// import { clearProfile } from '../../store/apps/userProfile/UserProfileSlice';
//import { AuthContext } from '../auth0/Auth0Context';

// Özel memoized selector (farklı bir isim verelim)
const selectAuthState = createSelector(
  [(state) => state.auth.isAuthenticated, 
   (state) => state.auth.user, 
   (state) => state.auth.loading],
  (isAuthenticated, user, loading) => ({
    isAuthenticated,
    user,
    loading
  })
);

const useAuth = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  // Yeni selector'ı kullanalım
  const { isAuthenticated, user, loading } = useSelector(selectAuthState);

  const logout = useCallback(() => {
    try {
      // AuthSlice'daki clearAuthData action'ını çağır
      dispatch(clearAuthData());
      clearSentryUser();
      
      // Local storage'ı temizle
      localStorage.removeItem('accessToken');
      localStorage.removeItem('user');
      localStorage.removeItem('nameSurname');
      localStorage.removeItem('mail');
      localStorage.removeItem('permissions');
      localStorage.removeItem('roles');
      
      // Diğer tüm local storage verilerini temizle
      localStorage.clear();
      
      // Login sayfasına yönlendir
      navigate('/auth/login', { replace: true });
    } catch (error) {
      console.error('Logout error:', error);
    }
  }, [dispatch, navigate]);

  const checkAuth = useCallback(() => {
    const token = localStorage.getItem('accessToken');
    return !!token && isAuthenticated;
  }, [isAuthenticated]);

  // useMemo ile return değerini memoize edelim
  const authValues = useMemo(() => ({
    isAuthenticated,
    user,
    loading,
    logout,
    checkAuth
  }), [isAuthenticated, user, loading, logout, checkAuth]);

  return authValues;
};

// Default export ekleyelim
export default useAuth;
// Named export da ekleyelim geriye dönük uyumluluk için
export { useAuth };
